import { render } from "./MapaCobertura.vue?vue&type=template&id=4bb745c5&scoped=true"
const script = {}

import "./MapaCobertura.vue?vue&type=style&index=0&id=4bb745c5&scoped=true&lang=css"

import exportComponent from "/home/hans/Proyectos/Clever/AlicaMedios/alicamedios.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bb745c5"]])

export default __exports__